module.exports = __webpack_public_path__ + "img/[憨笑].c1683f72.svg";